module.exports = __webpack_public_path__ + "img/symbol_4.51ec75c3.png";